import { useVerifiedPartnerCheck } from './useVerifiedPartnerCheck';
import { useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTING } from 'config';
import moment from 'moment';

export const useNavigateToIdVerification = (partnerId) => {
  const [isConfirmModalOpen, setConfirmModal] = useState(false);
  const history = useHistory();

  const { requestPartnerCheck, isLoading, data } =
    useVerifiedPartnerCheck(partnerId);

  const handleVerifyYourIdentity = useCallback(async () => {
    const { data } = await requestPartnerCheck(partnerId);

    if (data) {
      setConfirmModal(true);

      return;
    }

    history.push(ROUTING.ID_VERIFICATION);
  }, [history, partnerId, requestPartnerCheck]);

  const mappedIdentityData = useMemo(() => {
    if (!data) {
      return null;
    }

    return [
      {
        label: 'Full Name',
        value: `${data.firstName} ${data.lastName || ''}`,
      },
      {
        label: 'Date of Birth',
        value: moment(data.birthDate).format('DD/MM/YYYY'),
      },
      {
        label: 'Address',
        value: `${data.country || ''}, ${data.city || ''}, ${
          data.zipCode || ''
        }`,
      },
      {
        label: 'Phone Number',
        value: data.phoneNumber || '',
      },
    ];
  }, [data]);

  const handleCloseConfirmationModal = useCallback(() => {
    setConfirmModal(false);
    history.push(ROUTING.ID_VERIFICATION);
  }, [history]);

  return {
    mappedIdentityData,
    isConfirmModalOpen,
    handleCloseConfirmationModal,
    handleVerifyYourIdentity,
    isLoading,
  };
};
